import { ShieldX, RefreshCw } from "lucide-react";
import { fmtDateTime } from "@/lib/format";

// IP / cihaz engellendi ekranı
export function BannedScreen({ ban, onRetry }) {
  return (
    <div className="space-y-5 text-center" data-testid="login-banned">
      <div className="mx-auto h-16 w-16 rounded-2xl grid place-items-center bg-red-600/15 ring-1 ring-red-500/40">
        <ShieldX className="h-8 w-8 text-red-400" />
      </div>
      <div className="space-y-2">
        <h1 className="font-head text-2xl font-black tracking-tight">Erişim Engellendi</h1>
        <p className="text-sm text-white/60 leading-relaxed">Bu bağlantıdan çok sayıda hatalı deneme yapıldı. Güvenlik nedeniyle giriş kapatıldı ve <b className="text-white/85">yöneticiye bildirildi</b>.</p>
      </div>
      <div className="rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3 text-left text-xs space-y-1.5">
        {ban?.ip && <div className="flex justify-between gap-3"><span className="text-white/45">IP adresi</span><b className="font-mono text-white/85" data-testid="login-banned-ip">{ban.ip}</b></div>}
        {ban?.at && <div className="flex justify-between gap-3"><span className="text-white/45">Engellenme</span><b className="text-white/85">{fmtDateTime(ban.at)}</b></div>}
        <div className="text-white/50 pt-1">Hata sonucu engellendiyseniz yöneticiniz engeli <b className="text-white/75">Kullanıcılar & Ayarlar › Güvenlik</b> bölümünden kaldırabilir.</div>
      </div>
      <button type="button" onClick={onRetry} className="inline-flex items-center gap-1.5 text-xs text-white/55 hover:text-white transition-colors" data-testid="login-banned-retry">
        <RefreshCw className="h-3.5 w-3.5" />Engel kaldırıldıysa tekrar dene
      </button>
    </div>
  );
}
